import { render, staticRenderFns } from "./OrderAdd.vue?vue&type=template&id=9dea7972&scoped=true"
import script from "./OrderAdd.vue?vue&type=script&lang=js"
export * from "./OrderAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9dea7972",
  null
  
)

export default component.exports